import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import { validateEmail } from 'src/lib/utils/helpers'

const VerifyEmail = () => {
  const { t } = useLocale()
  const router = useRouter()
  const { email } = router.query

  const [counter, setCounter] = useState<number>(9)

  useEffect(() => {
    if (!Boolean(validateEmail(String(email)))) {
      handleVerifyButtonClick()
    }
  }, [email])

  useEffect(() => {
    const timer: any = counter > 0 ? setInterval(() => setCounter(counter - 1), 1000) : handleVerifyButtonClick()
    return () => clearInterval(timer)
  }, [counter])

  const handleVerifyButtonClick = () => {
    router.replace('/auth/login')
  }

  return (
    <div className='flex flex-col items-center mt-4 gap-11'>
      <div className='flex flex-col items-center gap-3'>
        <p className='text-[#ffffff] text-[18px] font-semibold'>{t('sign_in')}</p>
        <p className='text-[#B6B6BC] text-sm'>{t('verified_email_text', { email: email })}</p>
      </div>
      <div className='flex flex-col items-center gap-3 '>
        <button
          onClick={handleVerifyButtonClick}
          className='flex justify-center items-center h-8 text-sm font-semibold rounded-lg bg-primary-dark text-[#ffffff] w-[24.5rem]'
        >
          {t('verify_email')}
        </button>
        <p className='text-[#B6B6BC] text-sm relative'>
          {t('redirecting_text', { time: counter })}
          <span className='absolute'>{'.'.repeat(3)}</span>
        </p>
      </div>
    </div>
  )
}

export default VerifyEmail
